module.exports = __webpack_public_path__ + "img/features-bg_7.6bc6611e.png";